import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { converter } from 'helpers/converter';
import WithApa from 'newComponents/WithApa/WithApa';
import Typography from 'newComponents/Typography';
import Button from 'newComponents/Button';
import { UserContext } from 'providers/user.provider';
import constants from '../constants';

import './Logout.scss';

const Logout = ({ translations }) => {
  const { logout } = useContext(UserContext);
  return (
    <div className="deviceLogout">
      <div className="deviceLogoutText">
        <Typography
          element="p"
          dangerouslySetInnerHTML={{
            __html: converter.convertApa(
              translations,
              constants.myDevices.logout.title,
            ),
          }}
        />
        <Typography
          className="deviceLogoutLabel"
          element="p"
          dangerouslySetInnerHTML={{
            __html: converter.convertApa(
              translations,
              constants.myDevices.logout.label,
            ),
          }}
        />
      </div>
      <Button
        classes={['deviceLogoutButton']}
        color="primary"
        onClick={() => {
          logout({ all_sessions: 'true' });
        }}
      >
        {converter.convertApa(translations, constants.myDevices.logout.button)}
      </Button>
    </div>
  );
};

Logout.propTypes = {
  translations: PropTypes.object,
};

export default WithApa(Logout);
